import "./AcronymIcon.css";

const AcronymIcon = ({ name, width, height, fontSize, borderColor, onClick }) => {
  const getInitialsFromString = (str) => {
    if (!str) {
      return "";
    }

    let rgx = new RegExp(/(\p{L}{1})\p{L}+/, "gu");

    let acronym = [...str.matchAll(rgx)] || [];
    acronym = (acronym.shift()?.[1] || "") + (acronym.pop()?.[1] || "");
    return acronym.toUpperCase();
  };

  return (
    <span style={{ width, height, fontSize, borderColor }} className="acronym-icon" onClick={onClick}>
      {getInitialsFromString(name)}
    </span>
  );
};

export default AcronymIcon;
